// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"841":"4344c8cb","1227":"4344c8cb","2464":"7aaf09fe","3488":"4344c8cb","5281":"7ac6a1a1","6327":"4344c8cb","8380":"4344c8cb","9407":"4344c8cb","9692":"7f16631b","9920":"4344c8cb"}[chunkId] + ".chunk.css";
};